var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-grow-1",staticStyle:{"display":"inline-block"}},[_c('v-btn',{attrs:{"color":"teal white--text","x-small":"","fab":""},on:{"click":_vm.next}},[_c('v-icon',[_vm._v("double_arrow")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }